import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { AppBar, Typography, Button } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { useNavigate } from "react-router-dom";
import { selectedDbContext } from "../App";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function NavBar() {
  const { selectedDb, setSelectedDb } = useContext(selectedDbContext);
  const classes = useStyles();
  const navigate = useNavigate();
  const handleDbChange = () => {
    const path = window.location.pathname;
    switch (path) {
      case "/":
        setSelectedDb(selectedDb === "Store" ? "Employee" : "Store");
        break;
      case "/store":
      case "/employee":
        setSelectedDb(selectedDb === "Store" ? "Employee" : "Store");
        navigate(selectedDb === "Store" ? "/employee" : "/store");
        break;
      default:
        break;
    }
  };
  return (
    <div style={{ width: "100vw" }}>
      <AppBar position="sticky" color="default">
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            <Link to="/">
              <Button variant="outlined">Home</Button>
            </Link>
          </Typography>

          <Button onClick={handleDbChange}>
            {/* {`Alternative Database (${selectedDb})`} */}
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
